import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function withAlpha(color: string, alpha: number) {
  const normalized = color.trim()

  if (normalized.startsWith('#')) {
    const hex = normalized.slice(1)
    const expandedHex =
      hex.length === 3
        ? hex
            .split('')
            .map((character) => `${character}${character}`)
            .join('')
        : hex

    if (expandedHex.length === 6) {
      const red = Number.parseInt(expandedHex.slice(0, 2), 16)
      const green = Number.parseInt(expandedHex.slice(2, 4), 16)
      const blue = Number.parseInt(expandedHex.slice(4, 6), 16)

      return `rgba(${red}, ${green}, ${blue}, ${alpha})`
    }
  }

  if (normalized.startsWith('rgb(')) {
    return normalized.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`)
  }

  if (normalized.startsWith('rgba(')) {
    return normalized.replace(/,\s*[\d.]+\)$/, `, ${alpha})`)
  }

  return normalized
}
